import Vue from "vue";
import VueResource from "vue-resource";
Vue.use(VueResource);

import { nodeApi, railsApi } from "../../config";

if (process.env.NODE_ENV !== "production") {
  Vue.http.options.root = nodeApi;
} else {
  Vue.http.options.root = nodeApi;
}


export const Vote = Vue.resource(`${railsApi}/votes{/id}`)
export const Youtube = Vue.resource(`${railsApi}/youtubes{/id}`, {}, {
  subtitles: {method: "GET", url: `${railsApi}/youtubes{/id}/subtitles`},
});
export const Word = Vue.resource(`${railsApi}/words{/id}`);
export const Sentence = Vue.resource(`${railsApi}/sentences{/id}`);
export const User = Vue.resource(`${railsApi}/users{/id}`, {}, {
  confirm: { method: "GET", url: `${railsApi.replace('/v2', '')}/users/confirmation` },
  authFacebook: { method: "POST", url: `${railsApi}/auth/facebook/token` },
  authGoogle: { method: "POST", url: `${railsApi}/auth/google/token` },
});




// WEBPACK FOOTER //
// ./src/store/models/resources.js